import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

export const Icon = (props: FontAwesomeIconProps) => {
    return <FontAwesomeIcon {...props} />;
};